import React from "react";
import styled from "styled-components";
import { layout, LayoutProps, space, SpaceProps } from "styled-system";
import { Flex } from "../Flex";
import { Icon } from "../Icon";

export interface VideoThumbnailProps {
  videoUrl: string;
  backgroundImageUrl?: string;
  backgroundColor?: string;
}

const Wrapper = styled<any>(Flex)`
  ${space};
  ${layout};
  cursor: pointer;
`;

export const VideoThumbnail: React.FC<VideoThumbnailProps & SpaceProps & LayoutProps> = ({
  videoUrl,
  backgroundImageUrl,
  backgroundColor,
  ...props
}) => {
  const handleOnClick = () => window.open(videoUrl, "_blank");

  return (
    <Wrapper
      backgroundImage={`url(${backgroundImageUrl})`}
      backgroundSize="cover"
      backgroundPosition="center"
      backgroundColor={backgroundColor}
      height="0"
      textAlign="center"
      position="relative"
      onClick={handleOnClick}
      {...props}
    >
      <Icon
        position="absolute"
        top={0}
        bottom={0}
        left={0}
        right={0}
        margin="auto"
        icon="play"
        fontSize={35}
        fontWeight={500}
        color="white"
      />
    </Wrapper>
  );
};

VideoThumbnail.defaultProps = {
  backgroundColor: "muted",
  width: "20%",
  pb: "20%",
};
